/**
 * CV Health score gauge: one geometry and motion for the native SVG
 * (`HealthScoreGauge.tsx`) and the web SVG (`HealthScoreGauge.web.tsx`).
 * The values live in `@tabbio/utils/cv-health-view`, shared with the public
 * report, so every surface draws the same gauge. Pure module.
 */
export {
  CV_HEALTH_CHECK_STEPS,
  HEALTH_CHECK_WAVE,
  HEALTH_CHECK_WAVE_PATH,
  HEALTH_CHECK_WAVE_SPAN,
  HEALTH_GAUGE_ARC_LENGTH,
  HEALTH_GAUGE_HEIGHT,
  HEALTH_GAUGE_MAX_WIDTH,
  HEALTH_GAUGE_MID_STOP,
  HEALTH_GAUGE_MOTION,
  HEALTH_GAUGE_PATH,
  HEALTH_GAUGE_RADIUS,
  HEALTH_GAUGE_STOPS,
  HEALTH_GAUGE_STROKE,
  HEALTH_GAUGE_WIDTH,
  easeOutCubic,
  gaugeDashOffset,
  getCheckCount,
  getCheckProgress,
  getCheckStepStates,
  getScoreStrength,
  type CvHealthCheckCount,
  type CvHealthCheckStep,
  type CvHealthCheckStepState,
  type HealthGaugeStops,
  type HealthScoreStrength,
} from '@tabbio/utils/cv-health-view';
